import type { RotationCalendar } from "@shared/models/rotation-calendar"
import { difference, filter, find, includes, map, sortBy } from "lodash-es"
import type { DefaultDate } from "./shared"

export function filterForRelevantDates(
  rotationCalendar: RotationCalendar,
  effectiveDate: string,
  shouldFilterForRotationIds?: boolean,
  includedRotationIds?: Array<string>
) {
  return sortBy(
    filter(
      rotationCalendar.attributes.dates,
      (date) =>
        date.attributes.dateString >= effectiveDate &&
        (shouldFilterForRotationIds
          ? includes(includedRotationIds, date.attributes.rotationId)
          : true)
    ),
    (date) => date.attributes.dateString
  )
}

export function findRotationDate(rotationCalendar: RotationCalendar, dateString: string) {
  return find(
    rotationCalendar.attributes.dates,
    (date) => date.attributes.dateString === dateString
  )
}

/**
 * Generate the IDs of Rotations we don't have yet in this course/planbook yet
 */
export function pluckNewRotationIds(
  sourceRotationCalendar: RotationCalendar,
  defaultDates: Array<DefaultDate>
) {
  return difference(
    map(sourceRotationCalendar.attributes.rotations, (rotation) => rotation.id), // source rotation ids
    map(defaultDates, (date) => date.attributes.rotationId) // existingRotatinIds
  )
}
